import { ThemeProvider } from "@kalyzee/kalyzee-ui";
import Storage from "../../helpers/storage";

export const AppThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <ThemeProvider 
    preferredTheme={Storage.getTheme() ?? undefined}
    onPreferredTheme={theme => Storage.setTheme(theme)}
  > 
    {children}
  </ThemeProvider>
);